var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.loading)?_c('div',[_c('v-progress-circular',{attrs:{"indeterminate":"","color":"primary"}})],1):_c('div',[_c('app-form',{attrs:{"parentObject":{
      data: this.formData,
      pageTitle: this.pageTitle,
      pageTitleValue: this.pageTitleValue,
      errMsg: this.errMsg,
      isEdit: this.isEdit,
      isAdvanceEdit: this.isAdvanceEdit,
      pmAssessmentRecordDetailList: this.pmAssessmentRecordDetailList,
    }}}),(_vm.isErr)?_c('div',[_c('app-error',{attrs:{"parentError":{
        data: this.errMsg,
        isErr: this.isErr,
      }}})],1):_vm._e()],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }